import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, extractError } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message || "Revise su bandeja de entrada");
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#F9F8F6]">
      <div className="w-full max-w-sm bg-white border border-[#E2DFD8] rounded-md p-8">
        <div className="label-caps mb-2">Recuperar acceso</div>
        <h1 className="font-display text-2xl font-medium mb-2">Olvidé mi contraseña</h1>
        {sent ? (
          <p className="text-sm text-[#59645E] mb-6">
            Si el correo está registrado en Aequor, recibirá un enlace desde{" "}
            <strong>soporte@aequor.cl</strong> para restablecer su contraseña (válido 24 horas).
          </p>
        ) : (
          <p className="text-sm text-[#59645E] mb-6">
            Ingrese su correo de usuario. Le enviaremos instrucciones para crear una nueva contraseña.
          </p>
        )}
        {!sent && (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="email"
              required
              placeholder="Correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-[#E2DFD8] rounded-sm text-sm"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1B4332] text-white text-sm py-2.5 rounded-sm disabled:opacity-60"
            >
              {loading ? "Enviando…" : "Enviar enlace"}
            </button>
          </form>
        )}
        <p className="mt-6 text-center text-sm">
          <Link to="/login" className="text-[#1B4332] underline">
            Volver al inicio de sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
